import './App.css';
import Dashboard from './Components/Dashboard/Dashboard';
import AddUser from './Components/AddUser';
import Questionnaire from './Components/Questionnaire';
import Class from './Components/Classes/ClassList';
import Login from './Components/Login';
import { Routes, Route } from 'react-router-dom';
import InfrastructureDashboard from './Components/Board';
import AllTeachers from './Components/Teacher/AllTeachers';
import { ProtectedRoute, AuthPage } from './protectedRoute';
import { ProvideAuth } from './services/auth/authProvider';
import AddTeacher from './Components/Teacher/AddTeacher';
import TeacherProfile from './Components/Teacher/TeacherProfile';
import AddSchool from './Components/AddSchool';
import AddGrade from './Components/AddGrade';
import ClassList from './Components/Classes/ClassList';
import ClassDetail from './Components/Classes/ClassDetail';
import AllStudents from './Components/Student/AllStudent';
import StudentProfile from './Components/Student/StudentProfile';

function App() {
  return (
    <div className='App'>
      <Routes>
      <Route path='/' element={<Login />} />  
        <Route>
        
        
          <Route path='/questionnaire' element={<Questionnaire />} />
          <Route path='/allteachers' element={<AllTeachers />} />
          <Route path='/allStudents' element={<AllStudents />} />
          <Route path='/dashboard' element={<Dashboard heading="Admin's Dashboard" label3="Dropout" label1="Results Report" label2="Expenditure"/>} />
          <Route path='/finances' element={<InfrastructureDashboard />} />
          <Route path='/classes' element={<ClassList />} />
          <Route path='/class' element={<ClassDetail/>}/>
          <Route path='/teacherProfile' element={<TeacherProfile />} />
          <Route path='/studentProfile' element={<StudentProfile />} />
          <Route path='add-teacher' element={<AddTeacher />} />
          <Route path='add-student' element={<AddUser />} />
          <Route path='add-school' element={<AddSchool />} />
          <Route path='/add-grade' element={<AddGrade />} />
          <Route path='/questionnaire' element={<Questionnaire />} />
        </Route>

      </Routes>
    </div>
  );
}

export default App;
